package shared.ui.components

import kotlinx.html.*
import kotlinx.html.js.onClickFunction
import AppState
import Router

object BottomNav {
    fun render(parent: FlowContent) {
        parent.div("fixed bottom-6 left-1/2 transform -translate-x-1/2 z-50") {
            div("bg-dark-800/80 backdrop-blur-xl border border-dark-700/50 rounded-3xl shadow-2xl px-6 py-3 flex gap-2") {
                // Home
                navItem(
                    this,
                    iconPath = "/images/icons/home.png",
                    label = "Home",
                    page = "home",
                    isActive = AppState.currentPage == "home"
                )
                
                // Teams
                navItem(
                    this,
                    iconPath = "/images/icons/teams.png",
                    label = "Teams",
                    page = "teams",
                    isActive = AppState.currentPage == "teams"
                )
                
                // Profile
                navItem(
                    this,
                    iconPath = "/images/icons/profile.png",
                    label = "Profile",
                    page = "profile",
                    isActive = AppState.currentPage == "profile"
                )
            }
        }
    }
    
    private fun navItem(parent: DIV, iconPath: String, label: String, page: String, isActive: Boolean) {
        parent.button(classes = if (isActive) {
            "flex flex-col items-center gap-1 px-6 py-3 rounded-2xl bg-brand-cyan/20 border border-brand-cyan/30 transition-all duration-300 hover:bg-brand-cyan/30 min-w-[80px]"
        } else {
            "flex flex-col items-center gap-1 px-6 py-3 rounded-2xl hover:bg-brand-green/20 hover:border hover:border-brand-green/30 group transition-all duration-300 min-w-[80px]"
        }) {
            onClickFunction = {
                Router.navigateTo(page)
            }
            
            img(src = iconPath, alt = label) {
                classes = setOf(
                    "w-6", "h-6",
                    if (isActive) "opacity-100" else "opacity-60 group-hover:opacity-100"
                )
            }
            
            div(if (isActive) {
                "text-xs font-semibold text-brand-cyan"
            } else {
                "text-xs font-medium text-slate-400 group-hover:text-brand-green transition-colors"
            }) {
                +label
            }
        }
    }
}
